import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Paper from '@mui/material/Paper';
import Draggable from 'react-draggable';
import { Button }  from "@mui/material";
import { fni18n } from "../../services/commonService";

/**
 * @param { open(boolean), onClose(function), title(string), alerts(object), message(string) } props 
 * @returns 
 * @author minjlee
 * @since 2023. 03.10
 * @version 0.1
 */
const UAlertDialog = (props) => {
    return (
        <div>
            <Dialog
                open={props.open}
                onClose={props.onClose}
                PaperComponent={PaperComponent}
                aria-labelledby="draggable-dialog-title"
                fullWidth={true}
            >
                <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
                { props.title || fni18n("알림") }
                </DialogTitle>
                <DialogContent>
                <DialogContentText style={{ whiteSpace: 'pre-line' }}>
                {   props.alerts? (
                    Object.values(props.alerts)
                    .map((value, i) => (
                        <p key={i}>{value}</p>
                    ))
                    ): null
                }
                    <p>{fni18n(props.message)}</p>
                </DialogContentText>
                </DialogContent>
                <DialogActions>
                <Button variant="outlined" onClick={props.onClose}>Ok</Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}
export default UAlertDialog;

function PaperComponent(props) {
    return (
      <Draggable
        handle="#draggable-dialog-title"
        cancel={'[class*="MuiDialogContent-root"]'}
      >
        <Paper {...props} />
      </Draggable>
    );
}